import React from "react";
import { Card, CardContent, CardHeader } from "@shared/ui/card";
import { Badge } from "@shared/ui/badge";
import { Button } from "@shared/ui/button";
import { Eye } from "lucide-react";
import { SOPTemplate } from "@features/wx/dispatcher/types";
interface SOPDetailsCardProps {
  sop: SOPTemplate;
}
const getPriorityColor = (tag: string) => {
  switch (tag) {
    case "Hot":
    case "Critical":
      return "bg-red-100 text-red-800 border-0";
    case "Medium":
      return "bg-orange-100 text-orange-800 border-0";
    case "Low":
      return "bg-green-100 text-green-800 border-0";
    default:
      return "bg-gray-100 text-gray-800 border-0";
  }
};
export const SOPDetailsCard: React.FC<SOPDetailsCardProps> = ({ sop }) => {
  return (
    <Card className="bg-white border border-gray-200 rounded-lg shadow-sm">
      <CardHeader className="pb-4">
        <div className="flex items-start justify-between">
          <div className="flex items-start gap-4">
            {/* Large circular icon */}
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-xl">
              {sop.soId}
            </div>
            <div>
              <h2 className="card-heading-text mb-1">
                {sop.name}
              </h2>
              <p className="card-subheading-text mb-2">{sop.description}</p>
              <p className="text-xs text-gray-500">{sop.shortName}</p>
            </div>
          </div>
        </div>
      </CardHeader>

      <CardContent className="pt-0">
        {/* 4-column grid */}
        <div className="grid grid-cols-4 gap-6 mb-6">
          <div className="text-center border rounded-md p-2">
            <div className="card-value-text">
              {sop.estimatedCost}
            </div>
            <div className="card-subheading-text">Estimated Cost</div>
          </div>
          <div className="text-center border rounded-md p-2">
            <div className="card-value-text">
              {sop.estimatedTime}
            </div>
            <div className="card-subheading-text">Time</div>
          </div>
          <div className="text-center border rounded-md p-2">
            <div className="card-value-text">
              {sop.estimatedDowntime}
            </div>
            <div className="card-subheading-text">Downtime</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
